export enum ErrorTypeEnum {
  BadRequest = 'bad-request',
  InternalError = 'internal-error',
  ValidationError = 'validation-error',
  LoginRequired = 'login-required',
  AccessDenied = 'access-denied',
  AuthorizationFailed = 'authorization-failed',
  MethodNotAllowed = 'method-not-allowed',
  NotFound = 'not-found',
  NotImplemented = 'not-implemented',
  Conflict = 'conflict'
}
